import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface POSCommonInterface {
  discountsDrawer: boolean
  partnersDrawer: boolean
  specialInstructionsDrawer: boolean
  holdOrderDrawer: boolean
  checkoutDrawer: boolean
  deliveryDrawer: boolean
  addWithdrawDrawer: boolean
  holdOrderPanel: boolean
  orderReturnPanel: boolean
  bulkCartItemsPanel: boolean
  lostSalePanel: boolean
  inventorySearchModal: boolean
  orderManagementModal: boolean
  fulfillmentModal: boolean
}

const initialState: POSCommonInterface = {
  discountsDrawer: false,
  partnersDrawer: false,
  specialInstructionsDrawer: false,
  holdOrderDrawer: false,
  checkoutDrawer: false,
  deliveryDrawer: false,
  addWithdrawDrawer: false,
  holdOrderPanel: false,
  orderReturnPanel: false,
  bulkCartItemsPanel: false,
  lostSalePanel: false,
  inventorySearchModal: false,
  orderManagementModal: false,
  fulfillmentModal: false
}

export const posCommonSlice = createSlice({
  name: "posCommonSlice",
  initialState,
  reducers: {
    updateDrawer(
      state,
      action: PayloadAction<{
        key:
          | "discountsDrawer"
          | "partnersDrawer"
          | "specialInstructionsDrawer"
          | "holdOrderDrawer"
          | "checkoutDrawer"
          | "deliveryDrawer"
          | "addWithdrawDrawer"
          | "holdOrderPanel"
          | "orderReturnPanel"
          | "bulkCartItemsPanel"
          | "lostSalePanel"
          | "inventorySearchModal"
          | "orderManagementModal"
          | "fulfillmentModal"
        value: boolean
      }>
    ) {
      // false all drawer  and set the one that is comming in action payload
      Object.keys(state).forEach((key) => {
        if (action.payload.key !== key) {
          state[key as keyof typeof state] = false
        } else {
          state[key as keyof typeof state] = action.payload.value
        }
      })
    }
  }
})

export const posCommonReducer = posCommonSlice.reducer
export const { updateDrawer } = posCommonSlice.actions
